import { createAction } from 'redux-actions'
import {
  REQUEST_ADDRESS_DATA,
  SET_ADDRESS_STATE,
  SET_ADDRESS_DATA,
  SET_ADDRESS_DEFAULT,
  SET_ADDRESS_FORM,
  SET_ADDRESS_SELECTED
} from '../constants/addressConstant'

export let requestAddressData = createAction(REQUEST_ADDRESS_DATA)
export let setAddressState = createAction(SET_ADDRESS_STATE)
export let setAddressData = createAction(SET_ADDRESS_DATA)
export let setAddressDefault = createAction(SET_ADDRESS_DEFAULT)
export let setAddressForm = createAction(SET_ADDRESS_FORM)
export let setAddressSelected = createAction(SET_ADDRESS_SELECTED)
